import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar, Alert, AlertTitle, Typography } from '@mui/material';
import { alertNotificationSelector, popNotification } from '../store/notification';

export default () => {
  const notifications = useSelector(alertNotificationSelector);
  const dispatch = useDispatch();
  if (notifications.length) {
    return (
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={2000}
        open={Boolean(notifications?.length > 0)}
        key="info"
        onClose={() => dispatch(popNotification())}
      >
        <Alert elevation={2} severity="info" onClose={() => dispatch(popNotification())}>
          <AlertTitle>{notifications[0]?.title}</AlertTitle>
          <Typography>{notifications[0]?.message}</Typography>
        </Alert>
      </Snackbar>
    );
  }
  return false;
};
